import React from "react";
import { auth } from "../../firebase/firebase.utilies";
import "./style.css";

const UserPage = () => {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>403</h1>
        </div>
        <h2>We are sorry, access Denied!</h2>
        <p>
          The page you are looking for is unavailable to you, your account is
          registerd as a <b>User</b>.
        </p>
        <a href="">Go To User Page</a>
        <div>
          <button
            className="btn btn-primary mt-3"
            onClick={() => {
              auth.signOut();
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserPage;
